<div
  *ngIf="selectedSection?.type && selectedSection?.type !== SectionType.DESCRIPTION"
  class="dashboard-subsections-list-subsections"
  fxFill
  fxLayout="column"
  fxLayoutGap="10px"
>
  <form
    [formGroup]="subsectionsForm"
    dashboardConnectForm
    [connectForm]="selectedSubsection ? selectedSubsection : null"
    fxFill
    fxLayout="column"
    fxLayoutGap="10px"
  >
    <div fxLayout="row">
      <mat-tab-group
        fxFill
        mat-align-tabs="end"
        #languageTabs
        (selectedTabChange)="selectTemplateLanguage($event)"
        [disablePagination]="true"
        [selectedIndex]="selectedLanguage?.tabIndex"
      >
        <mat-tab *ngFor="let language of supportedLanguages" [label]="language.name">
          <ng-container *ngTemplateOutlet="tabContent"></ng-container>
        </mat-tab>
      </mat-tab-group>
      <ng-template #tabContent>
        <div formArrayName="translations" *ngFor="let item of translations?.controls; let i = index">
          <mat-form-field
            [formGroupName]="i"
            fxFill
            *ngIf="
              item.get('language').value === selectedLanguage.code &&
              item.get('identifier').value === SUBSECTION_NAME_IDENTIFIER
            "
          >
            <input matInput formControlName="translation" placeholder="{{ sectionTypeLabel }} Name" />
            <mat-error
              *ngIf="
                item.get('identifier').value === SUBSECTION_NAME_IDENTIFIER &&
                item.get('translation').hasError('required')
              "
            >
              {{ sectionTypeLabel }} Name is <strong>required</strong>
            </mat-error>
            <mat-error
              *ngIf="
                item.touched &&
                item.get('identifier').value === SUBSECTION_NAME_IDENTIFIER &&
                item.get('translation').hasError('maxlength')
              "
            >
              {{ sectionTypeLabel }} Name should have
              <strong> at most {{ item.get('translation').errors?.maxlength.requiredLength }}</strong> characters
            </mat-error>
          </mat-form-field>
        </div>
      </ng-template>
    </div>
    <div fxLayout="row" fxLayoutAlign="space-between">
      <div
        fxLayout="column"
        fxFlex="35"
        fxLayoutAlign="space-between stretch"
        *ngIf="selectedSection?.type === SectionType.DIMENSION"
      >
        <label class="dashboard-subsections-list-subsections-label">
          {{ sectionTypeLabel + ' Color' }}
        </label>
        <input
          [colorPicker]="color.value"
          [style.background]="color.value"
          (colorPickerChange)="color.setValue($event)"
          class="dashboard-subsections-list-subsections-color-picker"
        />
      </div>
      <div fxLayout="column" fxLayoutAlign="space-between stretch" fxFlex="65">
        <dashboard-image-upload
          formControlName="icon"
          [uuid]="iconUuid"
          [label]="sectionTypeLabel + ' Icon'"
          [isEdit]="isEditingSubsection"
          [isImageToEdit]="isImageToEdit"
          [imgPath]="imgPath"
          [keyForUpload]="keyForUpload"
          [idsForUpload]="idsForUpload"
          [size]="IMAGE_SIZES.SMALL"
        >
        </dashboard-image-upload>
      </div>
    </div>
  </form>
  <div fxLayout="row" fxLayoutAlign="end">
    <div fxLayout="row" fxLayoutAlign="end center" *ngIf="isEditingSubsection">
      <button mat-raised-button color="accent" (click)="saveSubsection()">
        {{ 'Save ' + sectionTypeLabel | uppercase }}
      </button>
      <button mat-button (click)="cancelEditingSubsection()">
        {{ 'Cancel' | uppercase }}
      </button>
    </div>
    <div fxLayout="column" fxLayoutAlign="space-between end" *ngIf="!isEditingSubsection">
      <button mat-raised-button color="accent" (click)="saveSubsection()">
        {{ 'Add ' + sectionTypeLabel | uppercase }}
      </button>
    </div>
  </div>

  <label *ngIf="subsections?.length" class="dashboard-subsections-list-subsections-label">
    {{ sectionTypeLabel + 's:' }}
  </label>
  <div fxLayout="column" fxLayoutAlign="space-between stretch" *ngIf="subsections.length">
    <mat-radio-group fxLayout="row" fxLayoutAlign="space-between start" [(ngModel)]="radioGroup">
      <div fxLayout="column" fxLayoutAlign="space-between start" fxLayoutGap="10px">
        <mat-radio-button
          *ngFor="let subsection of subsections"
          [value]="subsection"
          fxLayout="row"
          fxLayoutAlign="space-around start"
          (change)="setSelectedSubsection(subsection)"
        >
          {{ getSubsectionName(subsection) }}
        </mat-radio-button>
      </div>
      <div fxLayout="column" fxLayoutAlign="space-between start" fxLayoutGap="10px">
        <div *ngFor="let subsection of subsections" fxLayout="row" fxLayoutAlign="space-around end">
          <button
            mat-button
            class="dashboard-subsections-list-subsections-actions"
            (click)="removeSubsection(subsection)"
          >
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
    </mat-radio-group>
  </div>
</div>
